import type { AppShellTranslations } from "@/components/app/i18n/shell";

type RoleLabels = AppShellTranslations["sidebar"]["roles"];

/** Até duas iniciais a partir das palavras do nome (org ou usuário). */
export function getInitials(name: string): string {
  return name
    .trim()
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0])
    .join("")
    .toUpperCase();
}

const ROLE_KEYS: Record<string, keyof RoleLabels> = {
  owner: "owner",
  admin: "admin",
  colaborador: "collaborator",
  collaborator: "collaborator",
  partner: "partner",
  parceiro: "partner",
  support: "support",
  suporte: "support",
};

/** Papel traduzido (S9). Papel desconhecido aparece como veio; sem papel, string vazia. */
export function translateRole(role: string | null | undefined, labels: RoleLabels): string {
  if (!role) return "";
  const key = ROLE_KEYS[role.trim().toLowerCase()];
  return key ? labels[key] : role;
}
